import type { ColumnOrderState } from "@tanstack/react-table";

import { MESSAGE_TIME_COLUMN_ID, RECENT_MESSAGE_COLUMN_ID } from "@/components/DriverView/columns/columnIds";

/**
 * A saved driver-grid column order with the Message time column where new members see it: right after Most Recent Driver
 * Message. An order saved before the column existed lacks its id, and the table would append it at the end;
 * an order that names it, or one that names no message column, comes back as it is.
 */
export function placeMessageTimeColumn(order: ColumnOrderState): ColumnOrderState {
  if (order.includes(MESSAGE_TIME_COLUMN_ID)) return order;
  const after = order.indexOf(RECENT_MESSAGE_COLUMN_ID);
  if (after === -1) return order;
  return [...order.slice(0, after + 1), MESSAGE_TIME_COLUMN_ID, ...order.slice(after + 1)];
}
